/* SantaVinyl theme — vanilla JS, no dependencies */
(() => {
  'use strict';

  const SV = window.SV || { routes: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents, format = SV.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, decimals = 2, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      const fixed = (n / 100).toFixed(decimals).split('.');
      const whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return fixed[1] ? whole + decimal + fixed[1] : whole;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Snow ---------- */
  function initSnow() {
    const canvas = $('canvas.snow');
    if (!canvas || reduceMotion) return;
    const ctx = canvas.getContext('2d');
    const count = parseInt(canvas.dataset.snow, 10) || 70;
    let w, h, flakes = [];
    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = window.innerWidth; h = window.innerHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    const make = (top) => ({
      x: Math.random() * w,
      y: top ? -10 : Math.random() * h,
      r: Math.random() * 2.6 + 0.8,
      s: Math.random() * 0.7 + 0.35,
      drift: Math.random() * 0.6 - 0.3,
      phase: Math.random() * Math.PI * 2,
      o: Math.random() * 0.5 + 0.45
    });
    resize();
    const n = w < 700 ? Math.round(count * 0.55) : count;
    for (let i = 0; i < n; i++) flakes.push(make(false));
    window.addEventListener('resize', resize, { passive: true });

    let running = true;
    document.addEventListener('visibilitychange', () => {
      running = !document.hidden;
      if (running) requestAnimationFrame(tick);
    });
    function tick(t) {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      for (const f of flakes) {
        f.y += f.s;
        f.x += f.drift + Math.sin(t / 1600 + f.phase) * 0.35;
        if (f.y > h + 10) Object.assign(f, make(true));
        if (f.x > w + 10) f.x = -10; else if (f.x < -10) f.x = w + 10;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${f.o})`;
        ctx.shadowColor = 'rgba(160,190,220,.8)';
        ctx.shadowBlur = 3;
        ctx.fill();
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncements(root = document) {
    $$('[data-announce]', root).forEach((bar) => {
      const msgs = $$('.announce__msg', bar);
      if (msgs.length < 2 || bar.dataset.ready) return;
      bar.dataset.ready = '1';
      let i = 0;
      const speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      setInterval(() => {
        const cur = msgs[i];
        i = (i + 1) % msgs.length;
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        msgs[i].classList.remove('is-leaving');
        msgs[i].classList.add('is-active');
        setTimeout(() => cur.classList.remove('is-leaving'), 500);
      }, speed);
    });
  }

  /* ---------- Scroll to buy box ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-scroll-buy]');
    if (!link) return;
    const target = document.getElementById('buy');
    if (!target) return;
    e.preventDefault();
    const header = $('.section-header');
    const offset = header ? header.offsetHeight + 10 : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root = document) {
    const els = $$('.reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Cart ---------- */
  const Cart = {
    drawer: null,
    async get() {
      const res = await fetch(SV.routes.cartJs, { headers: { Accept: 'application/json' } });
      return res.json();
    },
    async change(line, quantity) {
      const res = await fetch(SV.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      return res.json();
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
    },
    render(cart) {
      this.updateCount(cart.item_count);
      const d = this.drawer;
      if (!d) return;
      const list = $('[data-cart-items]', d);
      $('[data-cart-total]', d).textContent = formatMoney(cart.total_price);
      $('[data-checkout-btn]', d).hidden = cart.item_count === 0;

      if (!cart.items.length) {
        list.innerHTML = `<div class="drawer__empty"><p class="big-emoji">🎅</p><p>Your sleigh is empty!</p>
          <a href="${SV.routes.root}#buy" class="btn btn--primary" data-drawer-close>Shop the turntable</a></div>`;
      } else {
        list.innerHTML = cart.items.map((item, i) => {
          const img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
          const variant = item.variant_title && !item.product_has_only_default_variant ? `<p class="cart-line__variant">${item.variant_title}</p>` : '';
          const discounts = (item.discounts || []).map((ds) => `<p class="cart-line__disc">🎁 ${ds.title}</p>`).join('');
          const was = item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : '';
          return `<div class="cart-line">
            ${img ? `<img class="cart-line__img" src="${img}" alt="" loading="lazy">` : '<span></span>'}
            <div class="cart-line__info">
              <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
              ${variant}${discounts}
              <div class="qty">
                <button type="button" data-line="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-line="${i + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
            </div>
            <div class="cart-line__price">${was}<strong>${formatMoney(item.final_line_price)}</strong>
              <button type="button" class="cart-line__remove" data-line="${i + 1}" data-qty="0">Remove</button></div>
          </div>`;
        }).join('');
      }

      const bar = $('[data-ship-bar]', d);
      const threshold = Number(SV.freeShipping) * 100;
      if (bar && threshold > 0 && cart.item_count > 0) {
        const left = threshold - cart.total_price;
        const pct = Math.min(100, (cart.total_price / threshold) * 100);
        $('[data-ship-text]', d).innerHTML = left > 0
          ? `You're <strong>${formatMoney(left)}</strong> away from FREE shipping 🚚`
          : '🎉 Yay! You unlocked <strong>FREE shipping</strong>';
        $('[data-ship-fill]', d).style.width = pct + '%';
        bar.hidden = false;
      } else if (bar) {
        bar.hidden = true;
      }
    },
    async open() {
      const d = this.drawer;
      if (!d) { window.location.href = SV.routes.cart; return; }
      this.render(await this.get());
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeBtn = $('.drawer__head [data-drawer-close]', d);
      if (closeBtn) closeBtn.focus();
    },
    close() {
      const d = this.drawer;
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    init() {
      this.drawer = $('[data-cart-drawer]');
      document.addEventListener('click', async (e) => {
        if (e.target.closest('[data-cart-open]') && this.drawer && SV.routes.cart) {
          e.preventDefault();
          this.open();
          return;
        }
        if (e.target.closest('[data-drawer-close]')) { this.close(); return; }
        const qtyBtn = e.target.closest('[data-cart-items] [data-line]');
        if (qtyBtn) {
          qtyBtn.disabled = true;
          const cart = await this.change(Number(qtyBtn.dataset.line), Math.max(0, Number(qtyBtn.dataset.qty)));
          this.render(cart);
        }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    }
  };

  /* ---------- Product section ---------- */
  function initProduct(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    const jsonEl = $('[data-product-json]', root);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = document.getElementById(root.dataset.formId);
    const idInput = form ? $('[data-variant-id]', form) : null;
    let variant = product ? (product.variants.find((v) => String(v.id) === String(idInput && idInput.value)) || product.variants[0]) : null;

    /* Gallery */
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    const slides = track ? $$('.gallery__slide', track) : [];
    const goTo = (i) => {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const currentIndex = () => (track ? Math.round(track.scrollLeft / track.clientWidth) : 0);
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    const prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', () => goTo(Math.max(0, currentIndex() - 1)));
    if (next) next.addEventListener('click', () => goTo((currentIndex() + 1) % slides.length));
    if (track && thumbs.length) {
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = currentIndex();
          thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
          const active = thumbs[i];
          if (active) active.parentElement.scrollTo({ left: active.offsetLeft - 40, behavior: 'smooth' });
        });
      }, { passive: true });
    }

    /* Bundle & save */
    const breaks = $('[data-breaks]', root);
    const qtyInput = form ? $('[data-quantity]', form) : null;
    const setQty = () => {
      if (!breaks || !qtyInput) return;
      const checked = $('input[type="radio"]:checked', breaks);
      $$('.break', breaks).forEach((b) => b.classList.toggle('is-selected', b.contains(checked)));
      if (checked) qtyInput.value = checked.dataset.qty;
    };
    const updateBreakPrices = () => {
      if (!breaks || !variant) return;
      $$('input[type="radio"]', breaks).forEach((input) => {
        const label = input.closest('.break');
        const qty = Number(input.dataset.qty) || 1;
        const pct = Number(input.dataset.pct) || 0;
        const full = variant.price * qty;
        const total = Math.floor((full * (100 - pct)) / 100);
        const compare = (variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price) * qty;
        $('[data-break-total]', label).textContent = formatMoney(total);
        const c = $('[data-break-compare]', label);
        c.textContent = formatMoney(compare);
        c.hidden = compare <= total;
      });
    };
    if (breaks) {
      breaks.addEventListener('change', setQty);
      setQty();
    }

    /* Variants */
    const picker = $('[data-variant-picker]', root);
    const updateVariantUI = () => {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      $$('[data-price]', root).forEach((el) => (el.textContent = formatMoney(variant.price)));
      const onSale = variant.compare_at_price > variant.price;
      $$('[data-compare]', root).forEach((el) => { el.textContent = formatMoney(variant.compare_at_price || 0); el.hidden = !onSale; });
      $$('[data-save]', root).forEach((el) => (el.hidden = !onSale));
      $$('[data-save-amount]', root).forEach((el) => (el.textContent = formatMoney((variant.compare_at_price || 0) - variant.price)));
      $$('[data-add-btn]', root).forEach((btn) => {
        btn.disabled = !variant.available;
        const label = $('[data-add-label]', btn);
        if (!label.dataset.default) label.dataset.default = label.textContent;
        label.textContent = variant.available ? label.dataset.default : 'Sold out';
      });
      updateBreakPrices();
      if (variant.featured_media) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (idx > -1) goTo(idx);
      }
      if (document.body.classList.contains('template-product')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };
    if (picker && product) {
      picker.addEventListener('change', () => {
        const selected = $$('fieldset', picker).map((fs) => {
          const c = $('input:checked', fs);
          return c ? c.value : null;
        });
        selected.forEach((v, i) => {
          const lbl = $(`[data-option-label="${i}"]`, picker);
          if (lbl) lbl.textContent = v;
        });
        const match = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (match) variant = match;
        else {
          $$('[data-add-btn]', root).forEach((btn) => { btn.disabled = true; $('[data-add-label]', btn).textContent = 'Unavailable'; });
          return;
        }
        updateVariantUI();
      });
    }

    /* Add to cart — impulse mode goes straight to checkout */
    if (form) {
      const errorEl = $('[data-form-error]', form);
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = e.submitter && e.submitter.matches('[data-add-btn]') ? e.submitter : $('[data-add-btn]', form);
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
        if (errorEl) errorEl.hidden = true;
        try {
          const res = await fetch(SV.routes.cartAdd, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
          if (SV.afterAdd === 'checkout') {
            window.location.href = '/checkout';
            return;
          }
          await Cart.open();
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        } finally {
          if (btn && SV.afterAdd !== 'checkout') { btn.classList.remove('is-loading'); btn.disabled = false; }
          if (btn && SV.afterAdd === 'checkout' && errorEl && !errorEl.hidden) { btn.classList.remove('is-loading'); btn.disabled = false; }
        }
      });
      // Restore buttons if the customer returns via the back button from checkout
      window.addEventListener('pageshow', (ev) => {
        if (ev.persisted) $$('[data-add-btn]', root).forEach((b) => { b.classList.remove('is-loading'); b.disabled = variant ? !variant.available : false; });
      });
    }

    /* Sticky add-to-cart */
    const sticky = $('[data-sticky-atc]', root);
    const mainBtn = form ? $('[data-add-btn]', form) : null;
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(mainBtn);
    }

    /* Countdown */
    $$('[data-countdown]', root).forEach(initCountdown);
  }

  function initCountdown(el) {
    const timeEl = $('[data-countdown-time]', el);
    const mode = el.dataset.mode;
    const pad = (n) => String(n).padStart(2, '0');
    const target = () => {
      if (mode === 'daily') {
        const d = new Date(); d.setHours(24, 0, 0, 0); return d;
      }
      const parts = (el.dataset.date || '').split('-').map(Number);
      if (parts.length !== 3 || parts.some(isNaN)) return null;
      return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
    };
    const tick = () => {
      const t = target();
      const diff = t ? t - new Date() : -1;
      if (diff <= 0) {
        $('.countdown__text', el).textContent = el.dataset.expired || '';
        if (!el.dataset.expired) el.hidden = true;
        clearInterval(timer);
        return;
      }
      const s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      timeEl.textContent = d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m ${pad(sec)}s` : `${pad(h)}:${pad(m)}:${pad(sec)}`;
    };
    const timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Carol jukebox ---------- */
  // Public-domain carol melodies as "NOTE:beats" (R = rest)
  const TUNES = {
    jingle: 'E4:1 E4:1 E4:2 E4:1 E4:1 E4:2 E4:1 G4:1 C4:1.5 D4:.5 E4:4 F4:1 F4:1 F4:1.5 F4:.5 F4:1 E4:1 E4:1 E4:.5 E4:.5 E4:1 D4:1 D4:1 E4:1 D4:2 G4:2',
    wish: 'G4:1 C5:1 C5:.5 D5:.5 C5:.5 B4:.5 A4:1 A4:1 A4:1 D5:1 D5:.5 E5:.5 D5:.5 C5:.5 B4:1 G4:1 G4:1 E5:1 E5:.5 F5:.5 E5:.5 D5:.5 C5:1 A4:1 G4:.5 G4:.5 A4:1 D5:1 B4:1 C5:3',
    deck: 'G4:1.5 F4:.5 E4:1 D4:1 C4:1 D4:1 E4:1 C4:1 D4:.5 E4:.5 F4:.5 D4:.5 E4:1.5 D4:.5 C4:1 B3:1 C4:2 G4:1.5 F4:.5 E4:1 D4:1 C4:1 D4:1 E4:1 C4:1 D4:.5 E4:.5 F4:.5 D4:.5 E4:1.5 D4:.5 C4:1 B3:1 C4:2',
    silent: 'G4:1.5 A4:.5 G4:1 E4:3 G4:1.5 A4:.5 G4:1 E4:3 D5:2 D5:1 B4:3 C5:2 C5:1 G4:3 A4:2 A4:1 C5:1.5 B4:.5 A4:1 G4:1.5 A4:.5 G4:1 E4:3',
    joy: 'C5:1 B4:.75 A4:.25 G4:1.5 F4:.5 E4:1 D4:1 C4:1.5 G4:.5 A4:1.5 A4:.5 B4:1.5 B4:.5 C5:3',
    tree: 'G4:1 C5:.75 C5:.25 C5:1.5 D5:.5 E5:.75 E5:.25 E5:1.5 E5:.5 D5:.5 E5:.5 F5:1 B4:1 D5:1 C5:2',
    hark: 'G4:1 C5:1 C5:1.5 B4:.5 C5:1 E5:1 E5:1 D5:1 G5:1 G5:1 G5:1.5 F5:.5 E5:1 D5:1 E5:2',
    faithful: 'G4:1 G4:2 D4:1 G4:1 A4:2 D4:2 B4:1 A4:1 B4:1 C5:1 B4:2 A4:1 G4:2',
    wenceslas: 'G4:1 G4:1 G4:1 A4:1 G4:1 G4:1 D4:2 E4:1 D4:1 E4:1 F#4:1 G4:2 G4:2'
  };
  const SEMI = { C: 0, 'C#': 1, D: 2, 'D#': 3, E: 4, F: 5, 'F#': 6, G: 7, 'G#': 8, A: 9, 'A#': 10, B: 11 };
  const freq = (n) => {
    const m = n.match(/^([A-G]#?)(\d)$/);
    const midi = (Number(m[2]) + 1) * 12 + SEMI[m[1]];
    return 440 * Math.pow(2, (midi - 69) / 12);
  };

  const Jukebox = {
    ctx: null, nodes: [], timer: null, audio: null, current: null, root: null,
    ensureCtx() {
      if (!this.ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        this.ctx = new AC();
      }
      if (this.ctx.state === 'suspended') this.ctx.resume();
      return this.ctx;
    },
    bell(ctx, out, f, t, dur) {
      const env = ctx.createGain();
      env.gain.setValueAtTime(0.0001, t);
      env.gain.exponentialRampToValueAtTime(0.5, t + 0.008);
      env.gain.exponentialRampToValueAtTime(0.0001, t + Math.max(dur * 1.8, 0.9));
      env.connect(out);
      [[f, 'sine', 1], [f * 2, 'sine', 0.35], [f * 3, 'triangle', 0.08], [f * 4.2, 'sine', 0.05]].forEach(([fr, type, g]) => {
        const o = ctx.createOscillator();
        const og = ctx.createGain();
        o.type = type; o.frequency.value = fr; og.gain.value = g;
        o.connect(og).connect(env);
        o.start(t); o.stop(t + Math.max(dur * 1.8, 0.9) + 0.05);
        this.nodes.push(o);
      });
    },
    crackle(ctx, out, length) {
      const sr = ctx.sampleRate, buf = ctx.createBuffer(1, sr * 2, sr), data = buf.getChannelData(0);
      for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * 0.015 + (Math.random() < 0.0006 ? (Math.random() * 2 - 1) * 0.6 : 0);
      const src = ctx.createBufferSource();
      src.buffer = buf; src.loop = true;
      const hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 1200;
      const g = ctx.createGain(); g.gain.value = 0.35;
      src.connect(hp).connect(g).connect(out);
      src.start(); src.stop(ctx.currentTime + length);
      this.nodes.push(src);
    },
    playTune(key) {
      const ctx = this.ensureCtx();
      if (!ctx) return 0;
      const notes = (TUNES[key] || TUNES.jingle).split(' ').map((s) => s.split(':'));
      const beat = 0.34;
      const master = ctx.createGain();
      master.gain.value = 0.32;
      master.connect(ctx.destination);
      this.nodes.push({ stop: () => master.disconnect() });
      let t = ctx.currentTime + 0.35; // brief needle-drop crackle first
      const start = t;
      notes.forEach(([n, b]) => {
        const d = parseFloat(b) * beat;
        if (n !== 'R') this.bell(ctx, master, freq(n), t, d);
        t += d;
      });
      const total = t - ctx.currentTime + 0.8;
      this.crackle(ctx, master, total);
      return (t - start + 1.2) * 1000;
    },
    stop() {
      clearTimeout(this.timer);
      this.nodes.forEach((n) => { try { n.stop(); } catch (_) { /* already stopped */ } });
      this.nodes = [];
      if (this.audio) { this.audio.pause(); this.audio = null; }
      if (this.current) this.setUI(this.current, false);
      this.current = null;
    },
    setUI(btn, playing) {
      const root = btn.closest('[data-jukebox]');
      const tt = $('[data-turntable]', root);
      btn.setAttribute('aria-pressed', String(playing));
      tt.classList.toggle('is-playing', playing);
      const disc = $('[data-disc]', root);
      disc.style.setProperty('--rc', getComputedStyle(btn).getPropertyValue('--rc'));
      $('[data-disc-label]', root).textContent = playing ? $('.record__label', btn).textContent : '🎄';
      const np = $('[data-now-playing]', root);
      if (!np.dataset.idle) np.dataset.idle = np.textContent;
      np.textContent = playing ? `Now playing: ${btn.dataset.title}` : np.dataset.idle;
    },
    play(btn) {
      const same = this.current === btn;
      this.stop();
      if (same) return;
      this.current = btn;
      this.setUI(btn, true);
      const src = btn.dataset.audio;
      if (src) {
        this.audio = new Audio(src);
        this.audio.addEventListener('ended', () => this.stop());
        this.audio.play().catch(() => { this.audio = null; this.schedule(btn); });
      } else {
        this.schedule(btn);
      }
    },
    schedule(btn) {
      const ms = this.playTune(btn.dataset.tune);
      this.timer = setTimeout(() => { if (this.current === btn) this.stop(); }, ms);
    },
    init() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-record]');
        if (btn) this.play(btn);
      });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); });
    }
  };

  /* ---------- Boot ---------- */
  function initAll(root = document) {
    initAnnouncements(root);
    initReveal(root);
    $$('[data-product-section]', root).forEach(initProduct);
    if (root.matches && root.matches('[data-product-section]')) initProduct(root);
  }

  const boot = () => {
    initSnow();
    Cart.init();
    Jukebox.init();
    initAll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', () => Jukebox.stop());
})();
